import MainPracticeScenario from './MainPracticeScenario';
import { constants, Globals } from '../../../../misc/helpers';
import { isContext } from 'vm';

export default class MainPracticeScenarioEnd {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void) {
	}

	start() {
		this.step1EmsArrives();
	}

	private step1EmsArrives() {
		var context = this;
		context.mainScenario.playSound('Step-20', '20');
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		Globals.stopTimer = true;
		if(context.mainScenario.aarPassed === true) {
			context.mainScenario.playSequence('EMSArrives', null, () => context.step2UnlockNextScenario());
		}
		else {
			context.step2UnlockNextScenario();
		}
	}

	private step2UnlockNextScenario() {
		//TODO: Unlock practice scenario D
		var context = this;
		if(context.mainScenario.aarPassed === true) {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.EmsContainer, {
				dispatch: this.mainScenario.gameManager.customData.dispatch
			});
			setTimeout(() => {
				this.step3ShowAar();
			}, 5000);
		}
		else {
			context.step3ShowAar();
		}
	}

	private step3ShowAar() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.Aar, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			data: this.mainScenario.getAARData(),
			onDone: () => {
				context.onDone();
			}
		});
	}
}